<script lang="ts">
	import type { Device } from 'src/types/Device';
	import CloudRecordings from './CloudRecordings.svelte';
	import { routeToDeviceSettings } from 'src/stores/ui/route-to-device-settings';
	import MediaPreview from './MediaPreview.svelte';
	import CameraCloudStoragePromoBanner from 'src/components/Settings/CameraCloudStorage/CameraCloudStoragePromoBanner.svelte';

	export let device: Device;

	let currentRecording = null;

	$: if (
		$routeToDeviceSettings[device.id]?.setting === 'camera_recordings' &&
		$routeToDeviceSettings[device.id]?.subSetting === 'view' &&
		$routeToDeviceSettings[device.id]?.params
	) {
		currentRecording = $routeToDeviceSettings[device.id].params;
		routeToDeviceSettings.resetTarget();
	}

	const handleSelected = (e) => {
		currentRecording = e.detail;
	};
</script>

<MediaPreview recording={currentRecording} />
<!--
	The promo banner is placed ABOVE `CloudRecordings` because the
	underlying `RecordingsList` forces the sidepanel scroll parent to
	`overflow: hidden` and stretches itself to consume all remaining
	vertical space — anything rendered after it in DOM is clipped
	off-screen, so the banner would never be visible when the list has
	many items.
-->
<CameraCloudStoragePromoBanner addMarginTop deviceId={device?.id} />
<CloudRecordings selected={currentRecording} {device} on:select={handleSelected} />
